// extracted by mini-css-extract-plugin
export default {"skeletonSize":"VideoComponent_skeletonSize__dzVnp","video":"VideoComponent_video__vPHug"};